"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
//
// Platform audio transcription component definition
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAudioTranscriptionComponentParameters = void 0;
exports.UserAudioTranscriptionComponentParameters = [
    {
        id: 'standAloneTag',
        label: 'Standalone Tag',
        description: 'Input Param - Array of standalone tags as strings',
        type: 'list',
        paramType: 'STRING_ARRAY',
        required: false,
    },
    {
        id: 'openCloseTag',
        label: 'Open-Close Tag',
        description: 'Input Param - Array of open-close tags as strings',
        type: 'list',
        paramType: 'STRING_ARRAY',
        required: false,
    },
    {
        id: 'recording',
        label: 'Recording',
        description: 'Input Param - Audio recording file input',
        type: 'file',
        paramType: 'FILE',
        required: false,
    },
    {
        id: 'start',
        label: 'Start',
        description: 'Input Param - Start position for transcription (e.g., seconds)',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'end',
        label: 'End',
        description: 'Input Param - End position for transcription (e.g., seconds)',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'transcript',
        label: 'Transcript',
        description: 'Output Param - Transcription result as a string',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'preFill',
        label: 'Pre-Fill',
        description: 'Input Param - Pre-filled transcription text',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'regularExpression',
        label: 'Regular Expression',
        description: 'Input Param - Regular expression for validation or matching',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'hideTagsButton',
        label: 'Hide Tags Button',
        description: 'Input Param - Hide the tags button in the UI',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'hideCurlyTagButton',
        label: 'Hide Curly Tag Button',
        description: 'Input Param - Hide the curly tag button in the UI',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'allowBlankTranscription',
        label: 'Allow Blank Transcription',
        description: 'Input Param - Allow the user to transcribe a blank audio',
        type: 'enum',
        paramType: 'ENUM',
        list: {
            ALLOW: 'Allow',
            ALLOW_WITH_TAGS: 'Allow only with [blank] Tag',
            DISALLOW: 'Disallow',
        },
        required: false,
    },
];
//# sourceMappingURL=UserAudioTranscriptionComponent.js.map